import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Handles template type selection for attachment type templates
// Loads type-specific form fields when template type is selected from dropdown
// Replaces: app/javascript/admin/settings/attachment_type_templates.js.erb
export default class extends Controller {
  static values = {
    url: String
  }

  change(event) {
    if (!this.urlValue) {
      return
    }

    // Get the entire form element
    const form = this.element.closest('form')
    if (!form) {
      logger.error('Could not find parent form')
      return
    }

    // Serialize form data manually (excluding file inputs, like jQuery serialize)
    const params = new URLSearchParams()

    const formElements = form.elements
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i]

      // Skip elements without names, disabled elements, file inputs, and resource field
      // (resource is ActiveStorage attachment with signed IDs that can't be serialized)
      if (!element.name || element.disabled || element.type === 'file' || element.name.includes('[resource]')) {
        continue
      }

      // Handle different input types
      if (element.type === 'checkbox' || element.type === 'radio') {
        if (element.checked) {
          params.append(element.name, element.value)
        }
      } else if (element.type === 'select-multiple') {
        for (let j = 0; j < element.options.length; j++) {
          if (element.options[j].selected) {
            params.append(element.name, element.options[j].value)
          }
        }
      } else {
        params.append(element.name, element.value)
      }
    }

    fetch(`${this.urlValue}?${params}`, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/javascript, application/javascript, */*'
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error(`Server error: ${response.status}\n${text}`)
        })
      }
      return response.text()
    })
    .then(script => {
      // Execute server-generated JavaScript (type_form.js.erb)
      // Using Function() instead of eval() for better bundler compatibility
      // Script is from our own server, not user input
      new Function(script)()
    })
    .catch(error => {
      logger.error('Error loading template type form:', error)
    })
  }
}
